import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/InV.png";

export const invasionDetail = {
  invasion: {
    id: "invasion",
    title: "Invasion",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "invasion",
        items: [
          {
            id: "invasion-1",
            title: "InVasion",
            description: "2001",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
